export default {
  methods: {
    fbInit() {
        window.fbLoginCallback = function(redirect) {
          FB.getLoginStatus(function(response) {
            if (response.status == 'connected') {
              window.location.href = '/users/auth/facebook?origin=' + redirect
            }
          })
        }
      window.fbAsyncInit = function() {
        window.FB.init({
          appId      : '453616162073786',
          xfbml      : true,
          version    : 'v2.7'
        })
        //this.fbCallback()

        // TODO check if logged in
        //window.fbLoginCallback()
     }
    }
  }
}
